import type { ReportingConfig } from '~/constants/reportingModal';

export type ReportingValidationState = {
  selectedReporting: number | null;
  initialConfig: Record<number, ReportingConfig>;
  startdate: string | Date | null;
  enddate: string | Date | null;
  selectedCity: number | null;
  selectedMarket: string;
  selectedMarkets: number[];
  selectedPeriodicity: string;
  selectedPlacer: string;
  billingSubscribedValue: number;
  cityRegroupValue: number;
  absencesubscribedcheckvalue: number;
  billingvolantcheckvalue: number;
  extensionsubscriptionvalue: number;
  cashDepositValue: number;
  unpaidmerchantvalue: number;
  eventvalue: number;
  recapMerchantValue: number;
  subscriptionInValue: number;
  subscriptionOutValue: number;
};

export type ReportingValidationErrors = {
  errorMessageStartDate: string;
  errorMessageEndDate: string;
  errorMessageCity: string;
  errorMessageAllCity: string;
  errorMessageMarket: string;
  errorMessageMarkets: string;
  errorMessagePeriodicity: string;
  errorMessagePlacer: string;
  errorMessageOnglet: string;
  errorMessageOnglet2: string;
};

const emptyErrors = (): ReportingValidationErrors => ({
  errorMessageStartDate: '',
  errorMessageEndDate: '',
  errorMessageCity: '',
  errorMessageAllCity: '',
  errorMessageMarket: '',
  errorMessageMarkets: '',
  errorMessagePeriodicity: '',
  errorMessagePlacer: '',
  errorMessageOnglet: '',
  errorMessageOnglet2: '',
});

export const validateReportingExport = (state: ReportingValidationState) => {
  const errors = emptyErrors();

  if (!state.selectedReporting) {
    return { isValid: false, errors };
  }

  const config = state.initialConfig[state.selectedReporting] || {};

  if (config.fromList === true && !state.startdate) {
    errors.errorMessageStartDate = 'Veuillez renseigner la date de début.';
  }

  if (config.toList === true && !state.enddate) {
    errors.errorMessageEndDate = 'Veuillez renseigner la date de fin.';
  }

  if (config.cityList === true && !state.selectedCity && state.selectedReporting !== 6) {
    errors.errorMessageCity = 'Veuillez sélectionner une ville.';
  }

  if (config.allCitiesList === true && !state.selectedCity) {
    errors.errorMessageAllCity = 'Veuillez sélectionner une ville.';
  }

  if (config.marketList === true && !state.selectedMarket) {
    errors.errorMessageMarket = 'Veuillez sélectionner un marché.';
  }

  if (config.multipleMarketList === true && state.selectedReporting !== 6) {
    const hasNoMarkets = state.selectedMarkets.length === 0;
    const requiresMarkets = (state.cityRegroupValue === 0 && (state.selectedCity || 0) > 0)
      || state.selectedReporting !== 3;
    if (hasNoMarkets && requiresMarkets) {
      errors.errorMessageMarkets = 'Veuillez sélectionner au moins un marché.';
    }
  }

  if (
    config.periodicityList === true
    && (state.billingSubscribedValue === 1 || [2, 3, 4, 5, 6].includes(state.selectedReporting))
    && !state.selectedPeriodicity
  ) {
    errors.errorMessagePeriodicity = 'Veuillez sélectionner une périodicité.';
  }

  if (config.placerList === true && !state.selectedPlacer) {
    errors.errorMessagePlacer = 'Veuillez sélectionner un placier.';
  }

  if (state.selectedReporting === 1) {
    const hasNoTab =
      (!state.absencesubscribedcheckvalue || state.absencesubscribedcheckvalue === 0)
      && state.billingvolantcheckvalue === 0
      && state.billingSubscribedValue === 0
      && state.extensionsubscriptionvalue === 0
      && state.cashDepositValue === 0
      && state.unpaidmerchantvalue === 0
      && state.eventvalue === 0
      && state.recapMerchantValue === 0;

    if (hasNoTab) {
      errors.errorMessageOnglet = 'Veuillez selectionner au moins un onglet.';
    }
  }

  if (state.selectedReporting === 2) {
    const hasNoTab =
      (!state.subscriptionInValue || state.subscriptionInValue === 0)
      && (!state.subscriptionOutValue || state.subscriptionOutValue === 0);
    if (hasNoTab) {
      errors.errorMessageOnglet2 = 'Veuillez selectionner au moins un onglet.';
    }
  }

  const isValid = Object.values(errors).every((value) => value.length === 0);
  return { isValid, errors };
};
